import {RemoteGetPrintGuide} from 'data/usecases/private/authorizations';
import {GetPrintGuide} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {AuthorizationsFlowEndpoints} from '../../endpoints';

export const makeGetPrintGuide = (): GetPrintGuide =>
	new RemoteGetPrintGuide(
		makeBFFApiUrl(AuthorizationsFlowEndpoints.printGuide),
		makeAuthorizeHttpClientDecorator(),
	);
